module.exports = __webpack_public_path__ + "static/10-1e3fdc9ab5e5457397b341c9480360b9.png";